import React from "react";
import moment from "moment";
import { useCurrentUserQuery } from "../../../../../../../api/queries/useUserQuery";
import { Table as SharedTable } from "../../../../../../../shared/Table/Table";
import { Skeleton } from "../../../../../../../shared/Skeleton/Skeleton";
import { Empty } from "../../../../../../../shared/Empty/Empty";
import { LoadMoreObserver } from "../../../../../../../shared/LoadMoreObserver/LoadMoreObserver";
import styles from "./styles.module.scss";
import {
  AppTranslation,
  useAppTranslation,
} from "../../../../../../../i18n/useAppTranslation";

/**
 * @param {object} param0
 * @param {{
 *    value: Array<Record<string, unknown>>;
 *    hasNextPage: boolean;
 *    isFetchingNextPage: boolean;
 *    isLoading: boolean;
 *    fetchNextPage: () => void;
 *    isLotNumberColVisible: boolean;
 * }} param0.data
 */
export function Table({ data }) {
  const { data: user } = useCurrentUserQuery();
  const { tCommon } = useAppTranslation.Common();

  const isEmpty = data.value.length === 0 && !data.isLoading;
  const isVisible = !data.isLoading && !isEmpty;

  const tableData = data.value.map((i) => ({
    key: i.id,
    lotNumber: i.inventory.batchId || tCommon("symbol.longDash"),
    clinic: i.clinic.name || tCommon("symbol.longDash"),
    patient: i.patient.fullName || tCommon("symbol.longDash"),
    date: moment
      .utc(i.createdAt)
      .format(`${user?.dateFormat} ${user?.timeFormat}`),
    action: i.actionLarge,
    beginningBalance: i.totalOldUnits,
    units: i.units,
    change: i.action,
    newBalance: i.totalNewUnits,
    doneBy: i.user.fullName || tCommon("symbol.longDash"),
  }));

  return (
    <div className={styles.root}>
      {data.isLoading && (
        <Skeleton count={15} height={40.5} borderRadius="0px" />
      )}
      {isEmpty && <Empty position="center" />}
      {isVisible && (
        <>
          <SharedTable
            bgColor="white"
            data={tableData}
            cols={[
              {
                data: "LOT#",
                accessor: "lotNumber",
                headColClassName: styles.colSmall,
                isVisible: data.isLotNumberColVisible,
              },
              {
                data: "Clinic",
                accessor: "clinic",
                headColClassName: styles.colBig,
                isVisible: true,
              },
              {
                data: <AppTranslation.Common path="label.patient" />,
                accessor: "patient",
                headColClassName: styles.colBig,
                isVisible: true,
              },
              {
                data: "Date",
                accessor: "date",
                headColClassName: styles.colBig,
                isVisible: true,
              },
              {
                data: "Action",
                accessor: "action",
                headColClassName: styles.colBig,
                isVisible: true,
              },
              {
                data: "Beginning Balance",
                accessor: "beginningBalance",
                headColClassName: styles.colSmall,
                isVisible: true,
              },
              {
                data: "Units",
                accessor: "units",
                headColClassName: styles.colSmall,
                isVisible: true,
              },
              {
                data: "Change",
                accessor: "change",
                headColClassName: styles.colSmall,
                isVisible: true,
              },
              {
                data: "New Balance",
                accessor: "newBalance",
                headColClassName: styles.colSmall,
                isVisible: true,
              },
              {
                data: "Done By",
                accessor: "doneBy",
                headColClassName: styles.colBig,
                isVisible: true,
              },
            ].filter((col) => col.isVisible)}
          />
          {data.hasNextPage && (
            <LoadMoreObserver
              noPaddingBottom
              loadMore={data.fetchNextPage}
              isLoading={data.isFetchingNextPage}
            />
          )}
        </>
      )}
    </div>
  );
}
